import { ColumnDef } from '@tanstack/react-table';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { useSubscription } from '@terminal/stores/use-subscription/useSubscription';
import { TopRankIcon } from '@terminal/widgets/knowledge-graph-widget/components/top-rank-icon/TopRankIcon';
import { useTranslation } from 'react-i18next';

import { CatalystsCell } from './cells/CatalystsCell';
import { CompanyCell } from './cells/CompanyCell';
import { ThemeCompanyWithInsights } from './TopCompaniesTable';
import styles from './TopCompaniesTable.module.scss';

export const RANK_COLUMN_ID = 'rank';
const COMPANY_COLUMN_ID = 'company';
export const CATALYSTS_COLUMN_ID = 'catalystInsights';

export const useTopCompaniesTableColumns =
  (): ColumnDef<ThemeCompanyWithInsights>[] => {
    const { t } = useTranslation(['widget']);
    const isBasicUser = useSubscription(state => state.isBasicUser());

    const columns: ColumnDef<ThemeCompanyWithInsights>[] = [
      {
        id: RANK_COLUMN_ID,
        header: t('widget:themeOverview.tabs.overview.rank'),
        cell: props => (
          <div className={styles.rankFlexRow}>
            <TopRankIcon rank={props.row.original.relationship.rank} />
          </div>
        ),
      },
      {
        id: COMPANY_COLUMN_ID,
        header: t('widget:themeOverview.tabs.overview.revampCompany'),
        cell: props => <CompanyCell entityTag={props.row.original.company} />,
      },
    ];

    if (!isBasicUser) {
      columns.push({
        id: CATALYSTS_COLUMN_ID,
        header: t('widget:themeOverview.tabs.overview.revampCatalystInsights'),
        cell: props => (
          <CatalystsCell
            variant="themeOverview"
            entityTag={props.row.original.company}
            insights={props.row.original.insights}
            earningsInsight={props.row.original.earningsInsight}
            source={POSTHOG_TRACKING_SOURCES.THEME_OVERVIEW}
          />
        ),
      });
    }

    return columns;
  };
